import { createApp } from 'vue'
import DialogRecharge from '@/components/DialogRecharge/DialogRecharge.vue'

export const useDialog = () => {
  const showRechargeDialog = () => {
    // 创建一个挂载容器
    const container = document.createElement('div')
    container.setAttribute('class', 'dialog-container')

    // 创建一个新的应用实例
    const app = createApp({
      render() {
        return h(DialogRecharge, {
          visible: true,
          onClose: () => {
            app.unmount()
            document.body.removeChild(container)
          },
        })
      },
    })

    // 挂载应用
    app.mount(container)
    document.body.appendChild(container)
  }

  return {
    showRechargeDialog,
  }
}
